import * as ActionTypes from "./ActionTypes";
import { baseUrl } from "../../shared/baseUrl";
import { toast } from "react-toastify";
//import axios from "../../axios";
import swal from "sweetalert";

const myheader = new Headers({
  Accept: "application/json",
  "Content-Type": "application/json",
});

// export const postLogin = (data) => {
//   return (dispatch) => {
//     dispatch(loginLoading(true));
//     axios
//       .post("login", data, {
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//         },
//       })
//       .then((login) => {
//         console.log(login);
//         return dispatch(addLogin(login));
//         // window.location.reload();
//       })
//       .catch((error) => dispatch(loginFailed(error)));
//   };
// };

export const postLogin = (data) => (dispatch) => {
  dispatch(loginLoading(true));
  console.log(data, myheader);
  return fetch(baseUrl + "login", {
    method: "post",
    headers: myheader,
    body: JSON.stringify(data),
  })
    .then(async (response) => {
      console.log(response);
      if (response.ok) {
        return response;
      }
      const errData = await response.json().catch(() => ({}));
      let errorMessage = errData.message || errData.error || response.statusText;
      let error = new Error(errorMessage);
      error.response = response;
      throw error;
    })
    .then((response) => response.json())
    .then((login) => {
      console.log(login);
      if (login.error) {
        // toast.error("UnAuthorized");
        swal(login.error.message || "Login Failed");
        dispatch(loginFailed(login.error));
      } else {
        // toast.success("Login Successfull!");
        dispatch(addLogin(login));
        // window.location.reload();
      }
    })
    .catch((error) => {
      swal(error.message || "Login Failed");
      dispatch(loginFailed(error));
    });
};

export const postCustomerLogin = (data) => (dispatch) => {
  dispatch(loginLoading(true));
  console.log(data, myheader);
  return fetch(baseUrl + "customerlogin", {
    method: "post",
    headers: myheader,
    body: JSON.stringify(data),
  })
    .then(async (response) => {
      console.log(response);
      if (response.ok) {
        return response;
      }
      const errData = await response.json().catch(() => ({}));
      let errorMessage = errData.message || errData.error || response.statusText;
      let error = new Error(errorMessage);
      error.response = response;
      throw error;
    })
    .then((response) => response.json())
    .then((login) => {
      console.log(login);
      if (login.error) {
        // toast.error("UnAuthorized");
        swal(login.error.message || "Login Failed");
        dispatch(loginFailed(login.error));
      } else {
        // toast.success("Login Successfull!");
        dispatch(addLogin(login));
        // window.location.reload();
      }
    })
    .catch((error) => {
      swal(error.message || "Login Failed");
      dispatch(loginFailed(error));
    });
};

export const addLogin = (login) => ({
  type: ActionTypes.ADD_LOGIN,
  login: login,
});

export const loginLoading = () => ({
  type: ActionTypes.LOGIN_LOADING,
});

export const loginFailed = (errMess) => ({
  type: ActionTypes.LOGIN_FAILED,
  errMess: errMess,
});

export const removeLogin = () => ({
  type: ActionTypes.REMOVE_LOGIN,
  login: [],
});
